export default {
  insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  },

  siblings(el) {
    return Array.prototype.filter.call(el.parentNode.children, (child) => {
      return child !== el;
    });
  },

  nextSiblings(el) {
    let siblings = [];
    el = el.nextElementSibling;
    while (el) {
      siblings.push(el);
      el = el.nextElementSibling;
    }
    return siblings;
  },

  parents(el, className) {
    for (el = el.parentNode; el && el !== document; el = el.parentNode ) {
      // if ( elem.matches( selector ) ) return elem;
      if (el.classList.contains(className)) {
        return el;
      }
    }
    return null;
  },

  offset(el) {
    return {
      left: el.getBoundingClientRect().left + document.body.scrollLeft,
      top: el.getBoundingClientRect().top + document.body.scrollTop,
    };
  },
};
